import { MapSearchResult } from '../../models/map-listing.model';
import { PolygonFilter } from '../../models/polygon-filter.model';
import { createAction, props } from '@ngrx/store';
import { Car, CarSearchResult } from '../../models/car-model';
import { CarSearch } from '../../models/car-search.model';
import { CarSortState } from '../states/car.state';
import { AdReport, ReportSearch } from '../../models/ad-report.model';
import { CreateReport } from '../../models/create-report.model';

export const searchCars = createAction('[Cars] Search Cars', props<{ query: CarSearch }>());

export const searchCarsSuccess = createAction(
  '[Cars] Search Cars Success',
  props<{ carResults: CarSearchResult | undefined }>()
);

export const searchCarsFailure = createAction(
  '[Cars] Search Cars Failure',
  props<{ error: string }>()
);

export const searchMapCars = createAction(
  '[Cars] Search Map Cars',
  props<{ mapQuery: CarSearch }>()
);

export const searchMapCarsSuccess = createAction(
  '[Cars] Search Map Cars Success',
  props<{ carMapResults: MapSearchResult | undefined }>()
);

export const searchMapCarsFailure = createAction(
  '[Cars] Search Map Cars Failure',
  props<{ error: string }>()
);

export const changeCarSort = createAction(
  '[Cars] Change Sort',
  props<{ active: CarSortState['active']; direction: CarSortState['direction'] }>()
);

export const changeCarPage = createAction('[Cars] Change Page', props<{ pageIndex: number }>());

export const changeCarPageSize = createAction(
  '[Cars] Change Page Size',
  props<{ pageSize: number }>()
);

export const getTopCars = createAction('[Cars] Get Top Cars');

export const getTopCarsSuccess = createAction(
  '[Cars] Get Top Cars Success',
  props<{ topCarResults: CarSearchResult }>()
);

export const getTopCarsFailure = createAction(
  '[Cars] Get Top Cars Failure',
  props<{ error: string }>()
);

export const getCar = createAction('[Cars] Get Car', props<{ carId: number }>());
export const getCarSuccess = createAction('[Cars API] Get Car Success', props<{ car: Car }>());
export const getCarFailure = createAction('[Cars API] Get Car Failure', props<{ error: string }>());

export const addCar = createAction('[Cars] Add Car', props<{ formData: FormData }>());
export const addCarSuccess = createAction('[Cars API] Add Car Success', props<{ car: Car }>());
export const addCarFailure = createAction('[Cars API] Add Car Failure', props<{ error: string }>());

export const updateCar = createAction(
  '[Cars] Update Car',
  props<{ formData: FormData; carId: number }>()
);
export const updateCarSuccess = createAction(
  '[Cars API] Update Car Success',
  props<{ car: Car }>()
);
export const updateCarFailure = createAction(
  '[Cars API] Update Car Failure',
  props<{ error: string }>()
);

export const upgradeCar = createAction('[Cars] Upgrade Car', props<{ carId: number }>());
export const upgradeCarSuccess = createAction(
  '[Cars API] Upgrade Car Success',
  props<{ car: Car }>()
);
export const upgradeCarFailure = createAction(
  '[Cars API] Upgrade Car Failure',
  props<{ error: string }>()
);

export const likeCar = createAction(
  '[Cars] Like Car',
  props<{ userId: number; carId: number; isLike: boolean }>()
);
export const likeCarSuccess = createAction('[Cars API] Like Car Success', props<{ car: Car; userId: number }>());
export const likeCarFailure = createAction(
  '[Cars API] Like Car Failure',
  props<{ error: string }>()
);

export const setCarSold = createAction('[Cars] Set Car Sold', props<{ carId: number }>());
export const setCarSoldSuccess = createAction(
  '[Cars API] Set Car Sold Success',
  props<{ car: Car }>()
);
export const setCarSoldFailure = createAction(
  '[Cars API] Set Car Sold Failure',
  props<{ error: string }>()
);

export const removeCar = createAction('[Cars] Remove Car', props<{ id: number }>());
export const removeCarSuccess = createAction(
  '[Cars API] Remove Car Success',
  props<{ id: number }>()
);
export const removeCarFailure = createAction(
  '[Cars API] Remove Car Failure',
  props<{ error: string }>()
);

export const updateSearchForm = createAction('[Cars] Update Form', props<{ form: CarSearch }>());

export const updateCarReportSearchForm = createAction(
  '[Cars] Update Report Search Form',
  props<{ form: ReportSearch }>()
);

export const searchCarReports = createAction(
  '[Cars] Search Car Reports',
  props<{ reportQuery: ReportSearch }>()
);

export const searchCarReportsSuccess = createAction(
  '[Cars] Search Car Reports Success',
  props<{ carReports: AdReport[] }>()
);

export const searchCarReportsFailure = createAction(
  '[Cars] Search Car Reports Failure',
  props<{ error: string }>()
);

export const addCarReport = createAction(
  '[Cars] Add Car Report',
  props<{ entity: string; id: number; model: CreateReport }>()
);
export const addCarReportSuccess = createAction(
  '[Cars API] Add Car Report Success',
  props<{ report: AdReport }>()
);
export const addCarReportFailure = createAction(
  '[Cars API] Add Car Report Failure',
  props<{ error: string }>()
);

export const updateCarReport = createAction(
  '[Cars] Update Car Report',
  props<{ reportId: number; status: string }>()
);
export const updateCarReportSuccess = createAction(
  '[Cars API] Update Car Report Success',
  props<{ report: AdReport }>()
);
export const updateCarReportFailure = createAction(
  '[Cars API] Update Car Report Failure',
  props<{ error: string }>()
);
export const loadCarViewPreference = createAction('[View] Load Car View Preference');

export const setCarMapView = createAction(
  '[View] Set Car Map View',
  props<{ isCarMapView: boolean }>()
);

export const toggleCarMapView = createAction('[View] Toggle Car Map View');

export const setCarPolygon = createAction(
  '[Cars] Set Polygon',
  props<{ polygon: PolygonFilter | null }>()
);
export const resetCarSearch = createAction('[Cars] Reset Search');
export const retryCarSearch = createAction('[Cars] Retry Search');

export const clearCarPolygon = createAction('[Car] Clear Polygon');

export const ensureCarList = createAction('[Car] Ensure Initial List');
